import css from "@/parts/ProductSpecificationSection/product-specification-section.module.scss";
import React from "react";
import * as Api from "@api";

interface ISketchFabProductSpinnerProps {
    product: Api.ProductFull;
    productSketchFabId?: string;
    productImage?: React.ReactNode;
    className?: string;
}

const SketchFabProductSpinner = ({ product, productImage, productSketchFabId, className }: ISketchFabProductSpinnerProps) => {
    return (<div className={`w-full ${className ?? ''}`}>
        {
            productSketchFabId !== undefined &&
            <div className="sketchfab-embed-wrapper md:sticky md:top-4 h-full">
                <iframe
                    title={product.title ?? "Product"}
                    frameBorder="0"
                    allowFullScreen
                    allow="autoplay; fullscreen; xr-spatial-tracking
                        xr-spatial-tracking
                        execution-while-out-of-viewport
                        execution-while-not-rendered web-share"
                    className={css["sketchfab"]}
                    src={`https://sketchfab.com/models/${productSketchFabId}/embed?autospin=1&transparent=1&ui_animations=0&ui_infos=0&ui_stop=0&ui_inspector=0&ui_watermark_link=0&ui_watermark=0&ui_hint=0&ui_ar=0&ui_help=0&ui_settings=0&ui_vr=0&ui_fullscreen=0&ui_annotations=0&dnt=1&autostart=1`}/>
            </div>
        }
        {
            productSketchFabId === undefined && productImage !== undefined &&
            <figure>
                {productImage}
            </figure>
        }
    </div>);
}

export default SketchFabProductSpinner;